"use client";

import { GetTickersAction } from "@/server-actions/ticker-actions";
import { useCallback, useEffect, useRef, useState } from "react";
import AnimatedDots from "@/components/ui/animated-dots";

const MoneyOvalTicker = () => {
  const [loading, setLoading] = useState(true);
  const containerRef = useRef<HTMLDivElement>(null);

  const fetchDataAndInitTicker = useCallback(async () => {
    setLoading(true);
    const res = await GetTickersAction({
      pagination: {
        limit: -1,
      },
    });

    const symbols = res?.data?.nodes?.map((a) => ({
      proName: a?.proName,
      title: a?.title,
    }));

    const script = document.createElement("script");
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
    script.async = true;
    script.innerHTML = JSON.stringify({
      symbols: symbols,
      showSymbolLogo: true,
      isTransparent: true,
      displayMode: "regular",
      colorTheme: "dark",
      locale: "en",
    });

    if (containerRef.current) {
      containerRef.current.innerHTML = ""; // Clear previous content
      containerRef.current.appendChild(script);
      setTimeout(() => {
        setLoading(false);
      }, 3300);
    }
  }, []); // Add dependencies here if needed

  useEffect(() => {
    fetchDataAndInitTicker();
  }, [fetchDataAndInitTicker]);

  return (
    <div className="w-full bg-neutral-900 relative text-white" id="ticker">
      {loading && (
        <div className="absolute text-sm top-0 left-0 right-0 bottom-0 min-h-12 text-neutral-300 bg-neutral-900 flex text-center justify-center items-center">
          <span className="flex items-center justify-center">
            Updating Data
            <span className="loader-dots mt-[7px] ml-0.5"></span>
          </span>
        </div>
      )}
      <div className="tradingview-widget-container " ref={containerRef}></div>
    </div>
  );
};

export default MoneyOvalTicker;
